import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { cloneDeep, find, map, findIndex } from 'lodash';
import { FilterSetup, FilterOption } from '../list-filter/list-filter.component';
import { IInputProps, InputVariant } from '@amobee/component-library';
import { AutoCompleteMappedItem } from '../../auto-complete/auto-complete.component';

@Component({
  selector: 'list-filter-selected',
  templateUrl: './list-filter-selected.component.html',
  styleUrls: ['./list-filter-selected.component.scss']
})
export class ListFilterSelectedComponent implements OnInit {

  public selectedFilters: FilterSetup[] = [];
  public _filterSetup: FilterSetup[];
  private _filters: object;

  @Input() public set filterSetup(value: FilterSetup[]) {
    this._filterSetup = map(value, (filter: FilterSetup) => {
      let extendObject = {};
      if (typeof filter.options === 'string') {
        // dynamic list
        extendObject = {
          isDynamic: true,
          showCloseButton: false
        }
      } else {
        // static list
        extendObject = {
          options: map(filter.options, (option) => {
            option.filter = filter.name;
            option.onClick = ($event: any) => {
              let subOption: FilterOption = $event.props;
              const item = find(this.selectedFilters, { name: subOption.filter }) as FilterSetup;
              this._filters[item.name] = subOption.name;
              item.currentSelection = subOption.label;
              this.emitFilters();
            };
            return option;
          })
        }
      }
      return Object.assign({}, filter, extendObject);
    });
  }
  public get filterSetup(): FilterSetup[] {
    return this._filterSetup;
  }

  @Input() public set filters(value: object) {
    this._filters = cloneDeep(value);
    for (const item of this._filterSetup) {
      let index = findIndex(this.selectedFilters, { name: item.name });
      if (this._filters[item.name] != undefined) {
        if (typeof item.options === 'string') {
          // dynamic list
          if (this._filters[item.name] != item.initialValue) {
            // TODO: load pre-selected object
            item.currentSelection = this._filters[item.name];
          } else {
            item.currentSelection = '';
          }
        } else {
          // static list
          item.currentSelection = (find(item.options, { name: this._filters[item.name] }) as FilterOption).label;
        }
        if (index === -1) {
          // add to selectedFilters
          this.selectedFilters.push(item);
        }
      } else {
        // remove from selectedFilters
        if (index > -1) {
          this.selectedFilters.splice(index, 1);
        }
      }
    }
  }
  public get filters(): object {
    return this._filters;
  }

  @Input() public hide?: boolean = false;
  @Output() public filterChanged = new EventEmitter<object>();

  public searchProps: IInputProps = {
    compact: true,
    variant: InputVariant.BORDERLESS,
    fluid: true,
    dark: false
  }

  constructor() { }

  ngOnInit() { }

  public removeFilter(index: number): void {
    //let index = findIndex(this.selectedFilters, { name: item.name });
    if (index > -1) {
      const filterTOoRemove = this.selectedFilters.splice(index, 1)[0];
      if (filterTOoRemove.isDynamic) {
        filterTOoRemove.currentSelection = '';
      }
      delete this._filters[filterTOoRemove.name];
      this.emitFilters();
    }
  }

  public setShowCloseButton(filter: FilterSetup, show: boolean) {
    filter.showCloseButton = show;
  }

  public handleOnFilterSelect(item: AutoCompleteMappedItem, filter: FilterSetup) {
    this._filters[filter.name] = item.value;
    filter.currentSelection = item.label;
    this.emitFilters();
  }

  public handleOnFilterClickOutside(searchString: String, filter: FilterSetup, index: number) {
    if (filter.currentSelection !== searchString) {
      this.removeFilter(index);
    }
  }

  public emitFilters(): void {
    this.filterChanged.emit(this._filters);
  }

}
